import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { BillingPeriodSelector } from '../BillingPeriodSelector';
import { BausControlsDropdown } from './BausControlsDropdown';
import { Background, PageContent } from './BillingPage.styled';
import { CatalogUsageCard } from './catalog/CatalogUsageCard';
import { CustomEventsUsageCard } from './customEvents/CustomEventsUsageCard';
import { GlobalSmsUsageCard } from './globalSms/GlobalSmsUsageCard';
import { JourneyEventsUsageCard } from './journeyEvents/JourneyEventsUsageCard';
import { MessagingUsageCard } from './messaging/MessagingUsageCard';
import { SmartIngestUsageCard } from './smartIngest/SmartIngestUsageCard';
import { UsersUsageCard } from './users/UsersUsageCard';
import { WhatsAppUsageCard } from './whatsApp/WhatsAppUsageCard';

export const BILLING_USAGE_TEXT = {
  header: 'Billing Usage',
};

export const BillingUsagePage = () => {
  const navBarHeight = useNavBarHeight();

  return (
    <>
      <PageHeader
        hasNormalPageWidth
        isSticky
        navBarHeight={navBarHeight}
        pageActions={
          <>
            <BillingPeriodSelector />
            <BausControlsDropdown />
          </>
        }
        variant={PAGE_HEADER_VARIANTS.TERTIARY}
      >
        {BILLING_USAGE_TEXT.header}
      </PageHeader>
      <Background>
        <PageContent>
          <MessagingUsageCard />
          <GlobalSmsUsageCard />
          <WhatsAppUsageCard />
          <UsersUsageCard />
          <CustomEventsUsageCard />
          <JourneyEventsUsageCard />
          <CatalogUsageCard />
          <SmartIngestUsageCard />
        </PageContent>
      </Background>
    </>
  );
};
